import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { HowItWorks } from '../components/HowItWorks';
import { CTABanner } from '../components/CTABanner';
export function HowItWorksPage() {
  const faqs = [{
    question: 'Can I really choose my own family member as a caregiver?',
    answer: 'Yes! That is our specialty. You select the family member you trust, and we handle all the training, certification, and compliance requirements.'
  }, {
    question: 'What if my family member has no caregiving experience?',
    answer: 'No problem. We provide complete training from scratch — CNA, CMT, Med Tech, CPR, and first aid certification.'
  }, {
    question: 'How long does the onboarding process take?',
    answer: 'Most family caregivers are fully certified and ready to begin in 24 to 48 hours.'
  }, {
    question: 'What does the background check include?',
    answer: 'We run comprehensive background screening including criminal history, fingerprinting, and reference verification.'
  }, {
    question: 'Is the training done on-site?',
    answer: 'Yes, all training, fingerprinting, and certification is completed at our facility for your convenience.'
  }, {
    question: 'What ongoing support do you provide?',
    answer: 'We provide continuous compliance monitoring, refresher training, and are always available for questions or concerns.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <main data-id="element-360">
      <PageHero title="How It Works" subtitle="From first call to certified caregiver in as little as 48 hours" data-id="element-361" />

      <HowItWorks data-id="element-362" />

      {/* FAQ Section */}
      <section className="py-24 px-4 bg-neutral-light" data-id="element-363">
        <div className="max-w-4xl mx-auto" data-id="element-364">
          <div className="text-center mb-16" data-id="element-365">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-4xl font-heading font-bold text-neutral-dark mb-4" data-id="element-366">
              Frequently Asked Questions
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-lg text-neutral-medium" data-id="element-367">
              Everything you need to know about our family caregiver
              certification process.
            </motion.p>
          </div>

          <div className="space-y-4" data-id="element-368">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-369">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-370">
                  <span className="font-heading font-bold text-lg text-neutral-dark pr-8" data-id="element-371">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-primary flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-372" />
                </button>

                <AnimatePresence data-id="element-373">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-374">
                      <div className="px-6 pb-5 text-neutral-medium leading-relaxed border-t border-gray-50 pt-4" data-id="element-375">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTABanner data-id="element-376" />
    </main>;
}